<template>
  <layout-navbar> Data Hub </layout-navbar>
  <slot />
  <default-footer />
</template>

<script>
import DefaultFooter from '@/components/default-layout-components/LayoutFooter'
import LayoutNavbar from '@/components/default-layout-components/LayoutNavbar'
export default {
  name: 'default-layout',
  components: { LayoutNavbar, DefaultFooter },
}
</script>

<style scoped>

</style>
